module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Delaware established a village in Ligonier Valley at the crossroads of two Indian paths possibly as early as 1727. By the time of the Forbes campaign of the Seven Years’ War, just over thirty years later, the Indians had abandoned Loyalhanning. The British strategy to take Fort Duquesne entailed building fortified posts across Pennsylvania, and so the Forbes Road and Fort Ligonier came into being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Promises to the Indians notwithstanding, white settlers surged over the Alleghenies, many even before hostilities ceased. Some of those choosing to migrate to Ligonier had been here with the army; some of their descendants are here still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems that once Ligonier Valley has been discovered, it lodges in your heart and soul. For those of us who grew up here, in any time period, it has been a magical place. More recent immigrants have come because of what they heard and saw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These stories, seen through fresh eyes and told by a new voice, offer a look back to the place from where we have come. Newer stories are constantly being created and will become part of our history, to be told at a time in our future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have known Jennifer Sopko since May 2004 as an extraordinary researcher and a gifted writer. She has here put her talents to relating our stories in a manner that I know will be appreciated by both long-time and newer residents as well as visitors to the Ligonier Valley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Read…and enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIRLEY")]), _vm._v(" G. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILLIS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCRUPE")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("2012 Awardee of the Arthur St. Clair Historic Preservation Award for")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("Preservation of the History of Ligonier Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("Pennsylvania Room Archivist, Ligonier Valley Library")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("January 2013")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf5090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foreword.vue
// module id = 69
// module chunks = 0